import { IndividualConfig } from 'ngx-toastr';

export const ToastrConfigCenterBiggerPermanent: Partial<IndividualConfig> = {
  positionClass: 'toast-top-center',
  disableTimeOut: true,
  titleClass: 'toast-title-bigger',
  messageClass: 'toast-message-bigger',
};
